import Layout from '../components/Layout';
import { useCluster } from '../context/ClusterContext';
import CostAllocationPanel from '../components/CostAllocationPanel';

// Tag/label cost attribution page (Phase 1, L4a). The allocation table now
// lives in the reusable <CostAllocationPanel> so the same view renders both
// here (standalone /cost-report) and inside the Monitoring "Cost Allocation"
// tab. This page is a thin wrapper that supplies the selected cluster + page
// chrome.
export default function CostReport() {
  const { selectedCluster } = useCluster();
  return (
    <Layout>
      <div className="px-6 py-5 space-y-2">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">Tag/Label Cost Report</h1>
          <p className="text-slate-500 text-sm mt-1">
            Group costs by namespace, team label, environment, or any pod / namespace label. Showback today;
            immutable chargeback snapshots are auto-written nightly.
          </p>
        </div>
        <CostAllocationPanel clusterId={selectedCluster?.id} embedded />
      </div>
    </Layout>
  );
}
